import { ROLES } from "../assets/constants/constants";

export const paths = [
    {
        id: "organization_chart",
        path: "/organigrama",
        label: "Organigrama",
        icon: <i className="ri-organization-chart white"></i>,
        roles: ROLES.ALL,
    },
    {
        id: "directory",
        path: "/directorio",
        label: "Directorio",
        icon: <i className="ri-contacts-book-3-line white"></i>,
        roles: ROLES.ALL,
    },
    {
        id: "user_management",
        path: "/usuarios",
        label: "Usuarios",
        icon: <i className="ri-group-line white"></i>,
        roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.COMMUNITY_MANAGER],
    },
    {
        id: "vacations",
        path: "/vacaciones",
        label: "Vacaciones",
        icon: <i className="ri-umbrella-line white"></i>,
        roles: ROLES.ALL,
        disabled: true,
    },
    {
        id: 'job_positions',
        path: "/vacantes",
        label: "Vacantes",
        icon: <i className="ri-briefcase-4-line white"></i>,
        roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.COMMUNITY_MANAGER],
    },
    {
        id: 'e-learning',
        path: "/aprendizaje",
        label: "Aprendizaje",
        icon: <i className="ri-graduation-cap-line white"></i>,
        roles: ROLES.ALL,
        disabled: true,
    },
    {
        id: 'performance_evaluation',
        path: "/evaluacion-desempeño",
        label: "Evaluación de Desempeño",
        icon: <i className="ri-line-chart-line white"></i>,
        roles: ROLES.ALL,
        disabled: true,
    },
    {
        id: 'policies',
        path: "/politicas-empresa",
        label: "Políticas de la Empresa",
        icon: <i className="ri-book-open-line white"></i>,
        roles: ROLES.ALL,
    },
    {
        id: "internal_communication",
        path: "/comunicacion-interna",
        label: "Comunicación Interna",
        icon: <i className="ri-speak-line white"></i>,
        roles: ROLES.ALL,
    },
    {
        id: "content-creation",
        path: "/creacion-contenido",
        label: "Creación de Contenido",
        icon: <i className="ri-palette-line white"></i>,
        roles: [ROLES.SUPER_ADMIN, ROLES.COMMUNITY_MANAGER],
    },
    {
        id: "anonymous_mailbox",
        path: "/buzon-anonimo",
        label: "Buzón Anónimo",
        icon: <i className="ri-megaphone-line white"></i>,
        roles: ROLES.ALL,
        disabled: true,
    },
    {
        id: "benefits",
        path: "/beneficios",
        label: "Beneficios",
        icon: <i className="ri-discount-percent-line white"></i>,
        roles: ROLES.ALL,
        disabled: true,
    },
    {
        id: "employee_survey",
        path: "/encuesta-laboral",
        label: "Encuesta Laboral",
        icon: <i className="ri-survey-line white"></i>,
        roles: ROLES.ALL,
        disabled: true,
    },
    {
        id: "documents",
        path: "/documentacion",
        label: "Documentación",
        icon: <i className="ri-inbox-archive-line white"></i>,
        roles: ROLES.ALL,
        disabled: true,
    },
    {
        id: "catalogs",
        path: "/catalogos",
        label: "Catálogos",
        icon: <i className="ri-folder-settings-line white"></i>,
        roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    },
    {
        id: "logout",
        path: "/logout",
        label: "Salir",
        icon: <i className="ri-logout-box-r-line white"></i>,
        roles: ROLES.ALL,
    },
];